import { setDefaults as i } from "./index90.mjs";
import { setI18n as r } from "./index89.mjs";
var p = {
  type: "3rdParty",
  init: function(t) {
    i(t.options.react), r(t);
  }
};
export {
  p as initReactI18next
};
